import { useCallback } from 'react';

import { useAuthStore } from '@/store/authStore';
import { showPlanFeature } from '@/store/planFeatureStore';
import type { PlanFeature } from '@/types/plan-access';
import { isPlanFeatureLocked } from '@/utils/plan-access';

/**
 * `locked` para a tela se desenhar; `guard()` para o toque: abre o aviso e
 * devolve `false` quando o recurso é pago e a pessoa está no gratuito.
 *
 * ```ts
 * const assistant = usePlanFeature('ASSISTANT');
 * onPress={() => assistant.guard() && router.push('/assistant')}
 * ```
 */
export function usePlanFeature(feature: PlanFeature) {
  const user = useAuthStore((s) => s.user);
  const locked = isPlanFeatureLocked(user, feature);
  const guard = useCallback(() => {
    if (!locked) return true;
    showPlanFeature(feature);
    return false;
  }, [locked, feature]);
  return { locked, guard };
}
